import {SIDE_NAV_LIGHT, DIR_LTR, SIDE_NAV_DARK} from 'constants/ThemeConstant';
import { env,USE_API } from './EnvironmentConfig'

export const APP_NAME = 'SIFO FJM';
export const NAMA_CLIENT = 'PT. Fokus Jasa Mitra';
//export const API_BASE_URL = (USE_API)?'http://127.0.0.1:8000'+env.API_ENDPOINT_URL:env.API_ENDPOINT_URL
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
//export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/`;
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = '/login'

export const APP_URL=env.WEB_URL

export const WEB_URL=env.WEB_URL

export const X_API_KEY=env.X_API_KEY;

export const VERSION_APP=env.VERSION_APP;

const IS_DEV_ENV = process.env.NODE_ENV === 'development';

export const THEME_CONFIG = {
	navCollapsed: (IS_DEV_ENV),
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	//navType: NAV_TYPE_SIDE,
	navType: "SIDE",
	topNavColor: '#3e82f7',
	headerNavColor: 'green',
	mobileNav: true,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
